import { createElement } from 'react';
import { createSvg } from './createSvg.js';
import '@vebox/etui-system';
import '@vebox/etui-system-elements';

const AddCircleGlyph = /*#__PURE__*/createElement("g", {
  id: "add_circle"
}, /*#__PURE__*/createElement("path", {
  d: "M58.29,40.5H43.5V25.71a1.5,1.5,0,0,0-3,0V40.5H25.71a1.5,1.5,0,0,0,0,3H40.5V58.29a1.5,1.5,0,0,0,3,0V43.5H58.29a1.5,1.5,0,0,0,0-3Z"
}), /*#__PURE__*/createElement("path", {
  d: "M42,18A24,24,0,1,1,18,42,24,24,0,0,1,42,18m0-3A27,27,0,1,0,69,42,27,27,0,0,0,42,15Z"
}));
const AddCircle = createSvg({
  name: 'add_circle',
  path: AddCircleGlyph
});

export default AddCircle;
export { AddCircleGlyph };
